import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Instagram, ArrowUpRight } from 'lucide-react';
import LegalModal from './LegalModal';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [legalModal, setLegalModal] = useState(null);

  const footerLinks = {
    company: [
      { name: 'About', path: '/about' },
      { name: 'Products', path: '/products' },
      { name: 'Contact', path: '/contact' }
    ],
    products: [
      { name: 'AiM LC', path: '/products#aim-lc' },
      { name: 'ScriptOtter', path: '/products#scriptotter' },
      { name: 'Gigma', path: '/products#gigma' }
    ]
  };

  return (
    <footer className="relative bg-black border-t border-white/[0.08] overflow-hidden">

      {/* Background glow */}
      <div className="absolute inset-0 bg-gradient-to-t from-white/[0.03] to-transparent pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-20">

        <div className="grid grid-cols-1 md:grid-cols-4 gap-14 mb-16">


          {/* Brand */}
          <div className="md:col-span-2">

            <Link to="/" className="inline-block group">
              <img
                src="/images/nrfstr-logotext.png"
                alt="NRFSTR"
                className="h-8 opacity-95 transition-transform duration-300 group-hover:scale-105"
              />
            </Link>

            <p className="text-white/55 text-sm leading-relaxed max-w-md mt-6">
              Building products that simplify complex technology,
              improve workflows, and create new possibilities.
            </p>


            <div className="flex items-center gap-3 mt-8">

              <a
                href="mailto:Tyseandavis42@gmail.com"
                className="h-10 w-10 rounded-xl bg-white/[0.06] border border-white/[0.08] flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10 transition"
                aria-label="Email"
              >
                <Mail size={18} />
              </a>


              <a
                href="https://instagram.com/xseandavisx"
                target="_blank"
                rel="noopener noreferrer"
                className="h-10 w-10 rounded-xl bg-white/[0.06] border border-white/[0.08] flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10 transition"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>

            </div>

          </div>



          {/* Company */}
          <div>

            <h3 className="text-white text-sm font-semibold mb-6">
              Company
            </h3>

            <ul className="space-y-4">

              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="flex items-center gap-1 text-white/55 text-sm hover:text-white transition group"
                  >
                    {link.name}
                    <ArrowUpRight
                      size={13}
                      className="opacity-0 group-hover:opacity-100 transition"
                    />
                  </Link>
                </li>
              ))}

            </ul>

          </div>




          {/* Products */}
          <div>

            <h3 className="text-white text-sm font-semibold mb-6">
              Products
            </h3>

            <ul className="space-y-4">

              {footerLinks.products.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="flex items-center gap-1 text-white/55 text-sm hover:text-white transition group"
                  >
                    {link.name}
                    <ArrowUpRight
                      size={13}
                      className="opacity-0 group-hover:opacity-100 transition"
                    />
                  </Link>
                </li>
              ))}

            </ul>

          </div>


        </div>



        {/* Bottom */}
        <div className="pt-8 border-t border-white/[0.08] flex flex-col md:flex-row justify-between items-center gap-4">

          <p className="text-white/35 text-sm">
            © {currentYear} NRFSTR. All rights reserved.
          </p>


          <div className="flex items-center gap-6">

            <button
  onClick={() => setLegalModal('privacy')}
  className="text-white/35 hover:text-white text-sm transition"
>
  Privacy
</button>

<button
  onClick={() => setLegalModal('terms')}
  className="text-white/35 hover:text-white text-sm transition"
>
  Terms
</button>

          </div>

        </div>


            </div>

      <LegalModal
        type={legalModal}
        onClose={() => setLegalModal(null)}
      />

    </footer>
  );
};

export default Footer;